const API_URL = 'https://marina.carreticacuentera.com/info';
const MEDIA = 'https://marina.carreticacuentera.com';
const PREGUNTAS = '/seleccion_unica' ;
const DECK = '/seleccion_unica_deck';

export { API_URL, MEDIA, PREGUNTAS, DECK };